require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-designers-can-survive-the-future.json") })
        }
      }, "path---blog-how-designers-can-survive-the-future");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-designers-can-survive-the-future!./.cache/json/blog-how-designers-can-survive-the-future.json
// module id = 836
// module chunks = 231608221292675